import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'sc-branch-selector',
	templateUrl: './branch-selector.component.html',
	styleUrls: ['./branch-selector.component.scss']
})
export class BranchSelectorComponent {
	public title: string;

	@Input() rowData: any;
	@Input() runAnimation: boolean;

	@Output() onClick: EventEmitter<any>;

	constructor() {
		this.title = '¿Que querés cotizar?';
		this.onClick = new EventEmitter();
	}

	handleOnClick(event) {
		this.onClick.emit(event);
	}
}
